import merge from 'deepmerge'
import { DateTimeFormats, I18nOptions, LocaleMessages } from 'vue-i18n'

const common: LocaleMessages = {
  en: {
    common: {
      yes: 'Yes',
      no: 'No',
      select: {
        select: 'Select',
        selectCategory: 'Select a Category',
        selectJob: 'select job role',
        selectCountry: 'select country'
      },
      sorry: "I'm sorry.Thank you for accessing it again later.",
      information: 'Your Information',
      all: 'ALL',
      new: 'NEW',
      discontinued: 'Discontinued',
      noResultMessage:
        'Sorry, please re-select your search criteria and try again.',
      pageNation: {
        resultsFor: 'Results for',
        showing: 'Showing'
      },
      accordion: {
        readMore: 'Read more',
        showLess: 'Show Less'
      },
      stepNav: {
        input: 'Input',
        confirmation: 'Confirmation',
        complete: 'Complete'
      },
      button: {
        detail: 'Detail',
        signIn: 'Sign in',
        signOut: 'Sign out',
        search: 'Search',
        reset: 'Reset',
        back: 'Back',
        submit: 'Submit',
        edit: 'Edit',
        delete: 'Delete',
        viewMore: 'View more',
        register: 'Register',
        unregister: 'Unregister',
        goBack: 'Go back',
        confirm: 'Confirm'
      },
      pagination: {
        first: 'First',
        previous: 'Previous',
        next: 'Next',
        last: 'Last'
      },
      bookmark: {
        remove: 'Remove Bookmark',
        add: 'Add Bookmark'
      }
    }
  },
  ja: {
    common: {
      select: {
        select: '選択してください',
        selectCategory: 'カテゴリを選択してください',
        selectJob: '職種を選択してください',
        selectCountry: '国を選択してください'
      },
      sorry: '申し訳ありません。時間をおいてから再度お試しください。',
      information: 'お客様情報',
      noResultMessage:
        '申し訳ありません。検索条件を再選択して再度お試しください。',
      pageNation: {
        resultsFor: '検索結果',
        showing: '表示中'
      },
      button: {
        detail: '詳細',
        signIn: 'ログイン',
        signOut: 'ログアウト',
        search: '検索',
        reset: 'リセット',
        back: '戻る',
        submit: '送信',
        edit: '編集',
        delete: '削除',
        viewMore: 'more',
        register: '登録',
        unregister: '退会',
        goBack: '戻る',
        confirm: '確認'
      },
      stepNav: {
        input: '情報入力',
        confirmation: '確認',
        complete: '完了'
      }
    }
  },
  'zh-hant': {
    common: {
      yes: 'Yes',
      no: 'No',
      select: {
        select: '選擇',
        selectCategory: '選擇類別',
        selectJob: '選擇職業類別',
        selectCountry: '選擇國家'
      },
      sorry: '很抱歉，請在稍後再次搜尋。',
      noResultMessage:
        '对不起，我们无法为您提供更多信息。 请重新选择搜索标准并再次尝试。',
      information: '基本資料',
      all: '顯示全部',
      new: 'NEW',
      pageNation: {
        resultsFor: '搜尋',
        showing: '顯示文件'
      },
      accordion: {
        readMore: '顯示更多',
        showLess: '顯示較少'
      },
      stepNav: {
        input: '填寫資料',
        confirmation: '資料確認',
        complete: '完成'
      },
      button: {
        detail: '詳細資訊',
        signIn: '登入',
        signOut: '登出',
        search: '搜尋',
        reset: '清除',
        back: '返回',
        submit: '提交',
        delete: '清除',
        viewMore: '顯示更多',
        register: '註冊',
        unregister: '註銷',
        goBack: '返回',
        confirm: '確認'
      },
      pagination: {
        first: '第一頁',
        previous: '上一頁',
        next: '下一頁',
        last: '第末頁'
      },
      bookmark: {
        remove: '移除收藏',
        add: '收藏'
      }
    }
  },
  es: {
    common: {
      yes: 'Sí',
      no: 'No',
      select: {
        select: 'Escoger',
        selectCategory: 'Seleccione una categoría',
        selectJob: 'Seleccionar rol de trabajo',
        selectCountry: 'Seleccionar país'
      },
      sorry: 'Lo siento. Gracias por acceder de nuevo más tarde.',
      information: 'Su información',
      all: 'TODOS',
      new: 'NUEVO',
      discontinued: 'Descontinuado',
      noResultMessage:
        'Lo sentimos, vuelve a seleccionar tus criterios de búsqueda e inténtalo de nuevo.',
      publicationDate: 'Fecha de publicación',
      themeKeyword: 'TEMA / PALABRA CLAVE',
      pageNation: {
        resultsFor: 'Resultados para',
        showing: 'Mostrando'
      },
      accordion: {
        readMore: 'Leer más',
        showLess: 'Ver menos'
      },
      stepNav: {
        input: 'Entrada',
        confirmation: 'Confirmación',
        complete: 'Íntegro'
      },
      button: {
        detail: 'Detalle',
        signIn: 'Ingresar',
        signOut: 'Cerrar sesión',
        search: 'Búsqueda',
        reset: 'Restablecer',
        back: 'Atrás',
        submit: 'Enviar',
        edit: 'Editar',
        delete: 'Borrar',
        viewMore: 'Ver más',
        register: 'Registrarse',
        unregister: 'Anular el registro',
        goBack: 'Volver',
        confirm: 'Confirmar'
      },
      pagination: {
        first: 'Primero',
        previous: 'Anterior',
        next: 'Próximo',
        last: 'Último'
      },
      bookmark: {
        remove: 'Eliminar marcador',
        add: 'Agregar marcador'
      }
    }
  },
  'pt-br': {
    common: {
      yes: 'Sim',
      no: 'Não',
      select: {
        select: 'Selecione',
        selectCategory: 'Selecione uma categoria',
        selectJob: 'selecione o seu cargo',
        selectCountry: 'Selecione o pais'
      },
      sorry: 'Sinto muito. Tente acessar novamente mais tarde.',
      information: 'Sua informação',
      all: 'TODOS',
      new: 'NOVO',
      discontinued: 'Interrompido',
      noResultMessage:
        'Desculpe, selecione seus critérios de pesquisa e tente novamente.',
      publicationDate: 'Data de publicação',
      themeKeyword: 'TEMA / PALAVRA-CHAVE',
      pageNation: {
        resultsFor: 'Resultados para',
        showing: 'Mostrando'
      },
      accordion: {
        readMore: 'Mostrar mais',
        showLess: 'Mostre menos'
      },
      stepNav: {
        input: 'Entrada',
        confirmation: 'Confirmação',
        complete: 'Completo'
      },
      button: {
        detail: 'Detalhe',
        signIn: 'Entrar',
        signOut: 'Sair',
        search: 'Procurar',
        reset: 'Reiniciar',
        back: 'Voltar',
        submit: 'Enviar',
        edit: 'Editar',
        delete: 'Excluir',
        viewMore: 'Veja mais',
        register: 'Inscreva-se',
        unregister: 'Cancelar inscrição',
        goBack: 'Voltar',
        confirm: 'Confirmar'
      },
      pagination: {
        first: 'Primeiro',
        previous: 'Anterior',
        next: 'Próximo',
        last: 'último'
      },
      bookmark: {
        remove: 'Remover favorito',
        add: 'Adicionar favorito'
      }
    }
  }
}

/**
 * 'short': サイト内検索、Document検索などの検索系で使用
 * 'month-long': Webinarで使用
 */
const dateTimeFormats: DateTimeFormats = {
  en: {
    short: {
      year: 'numeric',
      month: 'short',
      day: 'numeric'
    },
    'month-long': {
      year: 'numeric',
      month: 'long',
      day: 'numeric'
    }
  },
  ja: {
    short: {
      year: 'numeric',
      month: 'long',
      day: 'numeric'
    },
    'month-long': {
      year: 'numeric',
      month: 'long',
      day: 'numeric'
    }
  },
  'zh-hant': {
    short: {
      year: 'numeric',
      month: 'short',
      day: 'numeric'
    },
    'month-long': {
      year: 'numeric',
      month: 'short',
      day: 'numeric'
    }
  }
}

export default function (data: LocaleMessages[] = []): I18nOptions {
  data.push(common)

  const locale = drupalSettings.path.currentLanguage
    ? drupalSettings.path.currentLanguage
    : 'en'
  const options: I18nOptions = {
    locale: locale,
    fallbackLocale: 'en',
    messages: merge.all(data) as LocaleMessages,
    dateTimeFormats: dateTimeFormats
  }

  return options
}
